/**
 * Микрофронтенд рекламных/брендовых баннеров ad-banner-frontend.
 *
 * Значения — канонический кросс-хостовый контракт, не переименовывать:
 * - ENABLED_KEY — глобальный флаг конфига, одинаков во всех хостах;
 * - MANIFEST_SETTING_KEY — ключ настройки с сырым IMicrofrontendManifest,
 *   суффикс *Info к ключу не добавляется.
 */
export const AD_BANNER_MF_NAME = 'ad-banner-frontend';
export const AD_BANNER_MF_ENABLED_KEY = 'MarTech.AdBannerMicrofrontend.Enabled';
export const AD_BANNER_MF_MANIFEST_SETTING_KEY = 'adBannerMicrofrontendManifest';
